import React from 'react';
import PcrSelector from 'components/v2/pcr-selector/pcr-selector/PcrSelector';
import CPcrSelector from 'components/v2/pcr-selector/c-pcr-selector/CPcrSelector';
import { useToolCpcrsOfMainPcr, useUpdateToolMutation } from 'services/api/adminToolsQueriesAndMutations';
import { PatchedToolForAdminModel } from 'types/admin-tools/PatchedToolForAdminModel';
import { ToolForAdminModelVersion } from 'types/admin-tools/ToolForAdminModelVersion';

interface Props {
  toolData: PatchedToolForAdminModel;
  versionData: ToolForAdminModelVersion;
  errors: Partial<{ [key in keyof ToolForAdminModelVersion]: string }>;
}

const AdminEditToolVersionPcrs: React.FC<Props> = ({ toolData, versionData, errors }) => {
  const updateToolMutation = useUpdateToolMutation(toolData.id);
  const cpcrList = useToolCpcrsOfMainPcr(versionData.pcr?.id).data;

  return (
    <>
      <div className="w-full">
        <PcrSelector
          label="PCR"
          tooltip="Product category rules"
          pcr={versionData.pcr}
          onChangePcr={(newPcr) => {
            updateToolMutation.mutate({ propertyName: 'pcr', value: newPcr, versionOrd: versionData.ord });
            updateToolMutation.mutate({ propertyName: 'cpcr', value: null, versionOrd: versionData.ord });
          }}
          error={errors.pcr}
        />
      </div>
      <div className="w-full">
        <CPcrSelector
          label="C-PCR"
          tooltip="Complementary product category rules"
          cpcr={versionData.cpcr}
          cpcrList={cpcrList ?? []}
          onChangeCPcr={(newCpcr) => {
            updateToolMutation.mutate({ propertyName: 'cpcr', value: newCpcr, versionOrd: versionData.ord });
          }}
          required={false}
          disabled={!cpcrList || cpcrList.length === 0}
        />
      </div>
    </>
  );
};

export default AdminEditToolVersionPcrs;
